// src/CaixaDeEntrada.js
import React, { useState, useEffect } from 'react';
import { db } from './firebase';
import { collection, query, where, getDocs, orderBy, updateDoc, doc, arrayUnion } from 'firebase/firestore';
import { Typography, Box, Paper, CircularProgress, Link } from '@mui/material';

function CaixaDeEntrada({ user }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMessages = async () => {
      if (!user) {
        setLoading(false);
        return;
      }
      
      try {
        const q = query(
          collection(db, "mensagens"),
          where("destinatarios", "array-contains", user.uid),
          orderBy("dataEnvio", "desc")
        );

        const querySnapshot = await getDocs(q);
        const msgs = [];

        // Processa as mensagens e marca como lida
        const readUpdates = [];

        querySnapshot.forEach((document) => {
            const data = document.data();
            msgs.push({
                id: document.id,
                ...data,
                dataEnvio: data.dataEnvio.toDate()
            });

            // Lógica de Recibo de Leitura
            // Se o campo 'lidoPor' não existe ou se o meu ID não está nele:
            if (!data.lidoPor || !data.lidoPor.includes(user.uid)) {
                const msgRef = doc(db, "mensagens", document.id);
                // Adiciona à lista de promessas para executar em paralelo
                readUpdates.push(updateDoc(msgRef, {
                    lidoPor: arrayUnion(user.uid)
                }));
            }
        });

        setMessages(msgs);
        
        // Executa as atualizações de leitura no banco
        if (readUpdates.length > 0) {
            await Promise.all(readUpdates);
        }

      } catch (error) {
        console.error("Erro ao buscar mensagens:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, [user]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Caixa de Entrada</Typography>
      {messages.length === 0 ? (
        <Typography>Você não tem novas mensagens.</Typography>
      ) : (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {messages.map(msg => (
            <Paper key={msg.id} elevation={2} sx={{ p: 2, borderLeft: msg.lidoPor && msg.lidoPor.includes(user.uid) ? 'none' : '4px solid #1976d2' }}>
              <Typography variant="subtitle2">De: {msg.remetenteNome}</Typography>
              <Typography variant="caption" color="text.secondary">
                {msg.dataEnvio.toLocaleString('pt-BR')}
              </Typography>
              <Typography variant="body1" sx={{ my: 1 }}>{msg.mensagemTexto}</Typography>
              {msg.imagemUrl && (
                <Link href={msg.imagemUrl} target="_blank" rel="noopener noreferrer">
                  <Box component="img" src={msg.imagemUrl} alt="Anexo" sx={{ maxWidth: '100%', width: 200, height: 'auto', borderRadius: 1, mt: 1 }} />
                </Link>
              )}
            </Paper>
          ))}
        </Box>
      )}
    </Box>
  );
}

export default CaixaDeEntrada;